// @flow
import React, { Component } from 'react';

import Siren from '../../../assets/images/siren.png';
import './error.scss';


export default class Error extends Component {
    constructor( props ) {
        super( props );
        const { error } = props;
        switch ( error ) {
            case 'path':
            this.state = {
                hasError: true,
                errorText: 'Invalid URL. Please check your URL and try again.'
            };
            break;
            default:
            this.state = {
                hasError: false,
                errorText: ''
            };
            break;
        }
    }

    componentDidCatch( error, info ) {
        this.setState(
            {
                hasError: true,
                errorText: `${error} ${info.componentStack}`
            }
        );
    }
    
    render() {
        const { hasError, errorText } = this.state;
        if ( hasError ) {
            return (
                <div className="error-page">
                    <div className="error-container">
                        <img src={ Siren } />
                        <h1>Uh-oh!</h1>
                        <h3>We seem to be having difficulties</h3>
                        <h5>{ errorText }</h5>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
